<template>
  <el-tabs type="border-card" @tab-click="onTabChange">
    <el-tab-pane label="下单流水">
      <forwardRecords ref="forwardRecords"></forwardRecords>
    </el-tab-pane>
    <el-tab-pane label="退货流水">
      <reverseRecords ref="reverseRecords"></reverseRecords>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import forwardRecords from "@/pages/splitAccountManage/bill/recordComponents/forwardRecords.vue";
import reverseRecords from "@/pages/splitAccountManage/bill/recordComponents/reverseRecords.vue";

export default {
  components: { forwardRecords, reverseRecords },

  beforeRouteEnter(to, from, next) {
    next(async vm => {
      try {
        vm.onTabChange();
      } catch (error) {
        console.log(error);
        next();
      }
    })
  },
  methods: {
    onTabChange() {
      this.$refs.forwardRecords.initData(this.$route.query.billId, this.$route.query.subjectId);
      this.$refs.reverseRecords.initData(this.$route.query.billId, this.$route.query.subjectId);
    }
  },
};
</script>
